import { useSelector } from 'react-redux';
import { embedView, ROUTE_STARTUP_PATH } from 'routes';

const usePerformanceBreadcrumb = (path, startup) => {
  const literals = useSelector(state => state.i18n.literals.performance);
  const literalsCommon = useSelector(state => state.i18n.literals.common);

  const {
    PERFORMANCE,
    PERFORMANCE_ADD,
    PERFORMANCE_PENDING,
    PERFORMANCE_COMPARATOR,
    setPerformance,
    setPerformanceAdd,
    setPerformancePending,
    setPerformanceComparator,
  } = ROUTE_STARTUP_PATH;

  const mapLiterals = {
    [PERFORMANCE]: {
      name: literalsCommon.summary,
      path: setPerformance(startup),
    },
    [PERFORMANCE_ADD]: {
      name: literals.add,
      path: setPerformanceAdd(startup),
    },
    [PERFORMANCE_PENDING]: {
      name: literals.pending,
      path: setPerformancePending(startup),
    },
    [PERFORMANCE_COMPARATOR]: {
      name: literals.comparator,
      path: setPerformanceComparator(startup),
    },
  };

  return {
    routes: [
      { name: literals.title, path: path !== PERFORMANCE ? embedView(ROUTE_STARTUP_PATH.setPerformance(startup)) : null },
      { name: mapLiterals[path].name, path: embedView(mapLiterals[path].path) },
    ],
    nextRoutes: Object.keys(mapLiterals).map(key => ({
      name: mapLiterals[key].name,
      path: embedView(mapLiterals[key].path),
      actual: key === path,
    })),
  };
};

export default usePerformanceBreadcrumb;
